import { supabase } from "@/integrations/supabase/client";

/** Persists claimant reply and best-effort notifies ops (edge function may no-op if email unset). */
export async function submitNursingHomeClaimReply(claimId: string, reply: string): Promise<void> {
  const { error } = await supabase.rpc("submit_nursing_home_claim_reply", {
    p_claim_id: claimId,
    p_reply: reply,
  });
  if (error) throw error;

  try {
    const { error: notifyErr } = await supabase.functions.invoke("notify-admin-claim-reply", {
      body: { claim_id: claimId },
    });
    if (notifyErr) console.warn("notify-admin-claim-reply:", notifyErr);
  } catch (e) {
    console.warn("notify-admin-claim-reply failed:", e);
  }
}
